import { TableRow, TableCell, Box } from "@mui/material";

export default function NoRowsOverlay({
  columnLength,
}: {
  columnLength: number;
}) {
  return (
    <TableRow>
      <TableCell
        colSpan={columnLength || 6}
        align="center"
        classes={{
          root: "dark:border-jacarta-100 border-jacarta-100 dark:text-white text-jacarta-700 dark:bg-jacarta-600 bg-jacarta-50",
        }}
      >
        <Box
          sx={{ my: 5 }}
          style={{
            color: "#a3a3a3",
            fontSize: "1.2rem",
            fontWeight: 500,
          }}
        >
          No Rows Found
        </Box>
        {/* </div> */}
      </TableCell>
    </TableRow>
  );
}
